import { TExpTemp } from "@/types";

class MaiDianUtils {
  expTemp: TExpTemp | null;

  constructor () {
    this.expTemp = null;
  }

  setExpTemp (value: TExpTemp | null) {
    this.expTemp = value;
  }
}

const instance = new MaiDianUtils();

export default instance;